import { SwitcherButtonContainer } from './styled'
import { useLanguage } from '../../languages/language'

const SwitcherButton: React.FC<{
  position: number
  changeSwitcher: () => void
}> = ({ position, changeSwitcher }) => {
  const { texts } = useLanguage()
  return (
    <SwitcherButtonContainer $position={position} onClick={changeSwitcher}>
      <div>
        <div className="text">{texts.switcher[0]}</div>
        <div className="text">{texts.switcher[1]}</div>
        {/*<div className="text">{texts.switcher[2]}</div>*/}
      </div>
      <div className="sign">{texts.switcher[position]}</div>
    </SwitcherButtonContainer>
  )
}
export default SwitcherButton
